import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock, Radio } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/admin/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        const detail = data.detail;
        throw new Error(typeof detail === "string" ? detail : "Login failed — check your credentials");
      }
      localStorage.setItem("lbj_admin_token", data.token);
      localStorage.setItem("lbj_admin", JSON.stringify(data.admin));
      navigate("/admin");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-white flex items-center justify-center px-4">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-sm bg-[#12141D] border border-[#262a3d] rounded-3xl p-8 shadow-2xl"
      >
        <div className="flex items-center gap-2.5 mb-1.5">
          <span className="h-9 w-9 rounded-xl bg-gold/10 border border-gold/30 flex items-center justify-center">
            <Radio className="h-4 w-4 text-gold" />
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">Studio Control</span>
        </div>
        <h1 className="font-display text-2xl font-bold tracking-tight mb-6">
          Admin <span className="text-gold">Sign In</span>
        </h1>
        <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1.5">Email</label>
        <input
          data-testid="admin-email-input"
          type="email"
          required
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-obsidian border border-[#262a3d] rounded-xl px-4 py-3 text-sm mb-4 outline-none focus:border-gold/60 transition-colors"
        />
        <label className="block font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1.5">Password</label>
        <input
          data-testid="admin-password-input"
          type="password"
          required
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-obsidian border border-[#262a3d] rounded-xl px-4 py-3 text-sm mb-5 outline-none focus:border-gold/60 transition-colors"
        />
        {error && (
          <p data-testid="admin-login-error" className="text-coral text-xs mb-4 flex items-center gap-1.5">
            <Lock className="h-3.5 w-3.5" /> {error}
          </p>
        )}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={busy}
          className="w-full bg-gradient-to-r from-gold to-[#FB8500] text-black font-extrabold py-3.5 rounded-xl hover:scale-[1.01] active:scale-[0.99] transition-transform cursor-pointer disabled:opacity-70 flex items-center justify-center gap-2"
        >
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}
          ENTER THE CONTROL ROOM
        </button>
      </form>
    </div>
  );
}
